{
  "common.close": "Close",
  "common.athleteFallback": "athlete {id}",
  "splash.title": "{app} — Animated Activity Visualization",
  "splash.tagline": "Motion Mapping for Your Strava&nbsp;Data",
  "splash.demo": "Demo",
  "tab.query.title": "{name}'s map",
  "tab.query.heading": "Activities Query:",
  "tab.query.optDays": "recent days",
  "tab.query.optActivities": "recent activities",
  "tab.query.optIds": "Activity IDs",
  "tab.query.optDates": "Date-Range",
  "tab.query.idsPlaceholder": "enter activity ids here",
  "tab.query.after": "After:",
  "tab.query.before": "Before:",
  "tab.query.autozoom": "Auto-Zoom <i class=\"hf hf-bullseye\"></i> to query after import",
  "tab.query.queryButton": "<i class=\"hf hf-cloud-download\"></i> Query",
  "tab.query.createAccount": "Create an account and/or log in.",
  "tab.query.sports": "Sports:",
  "tab.query.allSports": "All sports",
  "tab.query.sportsExcept": "All except",
  "tab.query.sportsNone": "None",
  "tab.query.loadingSports": "Loading sports…",
  "tab.query.sportsFailed": "Couldn't load the sports on this map",
  "tab.query.noSports": "No activities yet",
  "tab.activities.title": "Rendered Activities",
  "tab.activities.clearSelection": "Clear Selection",
  "tab.activities.renderSelected": "Render selected",
  "tab.activities.zoomToSelection": "<i class=\"fas fa-search-plus\"></i> <i class=\"far fa-object-group\"></i> <i class=\"fas fa-search-minus\"></i> Zoom to selection",
  "tab.controls.title": "Layer Settings",
  "tab.controls.timescale": "Timescale <i>&tau;</i>",
  "tab.controls.timescaleHint": "playback speed",
  "tab.controls.period": "Period <i>T</i>",
  "tab.controls.periodHint": "activity ~ model",
  "tab.controls.dotSize": "Dot size",
  "tab.controls.pathWidth": "Path width",
  "tab.controls.pathWidthHint": "zero hides the paths",
  "tab.controls.colors": "Colors",
  "tab.controls.colorsHint": "rotate the palette",
  "tab.controls.shadows": "Shadows",
  "tab.profile.loginTitle": "Log in",
  "tab.profile.anonNote": "Log in with Strava to see your own activities, and to manage your Heatflask account.",
  "tab.profile.loginLink": "Log in with Strava",
  "tab.profile.editOnStrava": "Edit your profile on Strava",
  "tab.profile.indexNote": "We index your activity summaries for fast access.",
  "tab.profile.viewIndex": "View index",
  "tab.profile.sharedMaps": "Shared Maps",
  "tab.profile.sharedMapsNote": "Off: only you can see your activities on Heatflask. On: anyone with a link to your map can see the activities you have made public on Strava. Your private ones stay yours either way. <a id=\"profile-privacy-link\" href=\"#\" target=\"_blank\" rel=\"noopener\">How privacy works</a>",
  "tab.profile.adminDirectory": "User directory (admin)",
  "tab.profile.logout": "Log Out",
  "tab.profile.deleteAccount": "Delete Account",
  "tab.profile.deleteConfirm": "Delete your Heatflask account?\n\nThis removes your indexed activities and revokes Heatflask's access to your Strava data. It cannot be undone.",
  "tab.profile.languageHeading": "Language",
  "tab.profile.languageAuto": "Automatic",
  "tab.profile.translateNote": "<a id=\"translate-link\" target=\"_blank\" rel=\"noopener\">Help us fix or add new translations!</a>",
  "tab.profile.unitsHeading": "Units",
  "tab.profile.unitsAuto": "Automatic",
  "tab.profile.unitsMetric": "Metric (km, m)",
  "tab.profile.unitsImperial": "Imperial (mi, ft)",
  "tab.profile.textSizeHeading": "Text size",
  "tab.profile.textSmaller": "Smaller",
  "tab.profile.textReset": "Normal",
  "tab.profile.textLarger": "Larger",
  "tab.profile.mapDefaultsHeading": "Map defaults",
  "tab.profile.mapDefaultsNote": "Start with this basemap, terrain and layer settings whenever you open a map whose link does not set its own. Links you share still show exactly what you see.",
  "tab.profile.mapDefaultsSave": "Save as my defaults",
  "tab.profile.mapDefaultsForget": "Forget",
  "tab.info.title": "Info",
  "tab.info.controlsHeading": "Controls",
  "tab.info.shiftDragKey": "<kbd>Shift</kbd> + drag",
  "tab.info.shiftDragDesc": "Select activities in a box. On a touchscreen, tap <i class=\"hf-object-group\"></i> first, then drag with one finger. The last activity selected shows its details, and the activity list scrolls to it.",
  "tab.info.ctrlDragKey": "<kbd>Ctrl</kbd> + drag",
  "tab.info.ctrlDragDesc": "Rotate and tilt the map in 3D, or use two fingers",
  "tab.info.spaceKey": "<kbd>Space</kbd>",
  "tab.info.spaceDesc": "Open or close the sidebar",
  "tab.info.arrowsKey": "<kbd>&uarr;</kbd> <kbd>&darr;</kbd>",
  "tab.info.arrowsDesc": "Previous or next sidebar tab",
  "tab.info.escKey": "<kbd>Esc</kbd>",
  "tab.info.escDesc": "Close the sidebar",
  "tab.info.liveUrlHeading": "Live URL",
  "tab.info.liveUrlDesc": "The map view and the animation settings are kept in the page's URL, so anyone you share it with sees the same view.",
  "tab.info.videoHeading": "Video Export",
  "tab.info.videoDesc": "The <i class=\"hf-video-camera\"></i> button records the animation as an MP4: tap it, size the box over the part of the map you want, and tap again to record. One full loop of the animation is recorded, so the video repeats seamlessly; a loop longer than {max} seconds (the longest video Strava accepts) is cut off at {max}.",
  "tab.info.contributeHeading": "Contribute",
  "tab.info.sponsor": "<i class=\"hf-github\"></i> Sponsor on GitHub",
  "tab.info.contactsHeading": "Contacts",
  "map.basemapAndTerrain": "Basemap and terrain",
  "map.pauseAnimation": "Pause animation",
  "map.resumeAnimation": "Resume animation",
  "capture.record": "Record video ({period}s loop)",
  "capture.recordTruncated": "Record video (one cycle is {period}s; only the first {max}s will be recorded)",
  "capture.recordArea": "Record the area inside the box",
  "capture.stop": "Stop recording",
  "capture.selectionTooSmall": "selection is too small",
  "capture.saved": "saved {name} ({size})",
  "capture.cancelled": "capture cancelled",
  "capture.failed": "capture failed: {error}",
  "capture.loadingEncoder": "loading encoder…",
  "capture.waitingForMap": "waiting for the map to load…",
  "capture.encoding": "encoding… {percent}%",
  "capture.finalizing": "finalizing…",
  "share.title": "Share a link to this map",
  "share.copied": "link copied",
  "share.copiedUnshared": "link copied — but your map is not shared, so no one else can open it. Turn on Shared Maps to change that.",
  "share.unshared": "Your map is not shared, so no one else can open this link. Turn on Shared Maps to change that.",
  "share.copyThis": "Copy this link:",
  "update.available": "A new version of Heatflask is available.",
  "update.reload": "Reload",
  "import.title": "Importing",
  "import.stop": "Stop",
  "import.stopping": "stopping…",
  "import.contacting": "contacting Strava…",
  "import.countOf": "{received} of {total} activities",
  "import.count": "{received} activities",
  "import.waitStrava": "Paused by Strava's download limit until {time}. Leave this open; reloading won't make it faster.",
  "import.waitRationed": "You've had today's fast downloads. The rest continue at {time}, more slowly. Leave this open.",
  "import.dailyLimit": "Strava's daily download limit is used up. Try again after {time}.",
  "import.dailyRationed": "You've had your share of Strava downloads for today. Try again after {time}.",
  "import.noActivitiesYet": "Your Strava account has no activities yet. Record or upload one on Strava and it will appear here.",
  "table.noActivities": "no activities",
  "table.untitled": "(untitled)",
  "users.pageTitle": "{app} — User Directory",
  "users.heading": "User Directory",
  "users.headingAdmin": "Registered Users ({count})",
  "users.emptyAdmin": "No registered users.",
  "users.errParams": "could not read page parameters: {details}",
  "users.errLoad": "could not load the directory: {error}",
  "users.col.id": "ID",
  "users.col.name": "Name",
  "users.col.city": "City",
  "users.col.region": "Region",
  "users.col.country": "Country",
  "users.col.indexAccess": "Index access",
  "users.col.language": "Language",
  "users.col.browser": "Browser",
  "users.languages": "Translations in use ({known} users known): {list}",
  "users.today": "today",
  "users.yesterday": "yesterday",
  "users.daysAgo": "{count} days ago",
  "users.monthsAgo": "{count} mo ago",
  "users.yearsAgo": "{count} yr ago",
  "activities.pageTitle": "{app} — Activity Index",
  "activities.heading": "Activity Index",
  "activities.fetching": "Fetching activities...",
  "activities.rateLimit": "Strava rate limit reached; resuming at {time}",
  "activities.noData": "Sorry no data &#128577;",
  "activities.colServerCache": "Track cached on the server (Mongo)",
  "activities.colBrowserCache": "Track cached in this browser",
  "activities.cachedServer": "Track for {id} is cached on the server",
  "activities.notCachedServer": "Track for {id} is not cached on the server",
  "activities.cachedBrowser": "Track for {id} is cached in this browser",
  "activities.notCachedBrowser": "Track for {id} is not cached in this browser",
  "sport.AlpineSki": "Alpine Ski",
  "sport.BackcountrySki": "Backcountry Ski",
  "sport.Badminton": "Badminton",
  "sport.Basketball": "Basketball",
  "sport.Canoeing": "Canoe",
  "sport.Cricket": "Cricket",
  "sport.Crossfit": "Crossfit",
  "sport.Dance": "Dance",
  "sport.EBikeRide": "E-Bike Ride",
  "sport.Elliptical": "Elliptical",
  "sport.EMountainBikeRide": "E-Mountain Bike Ride",
  "sport.Golf": "Golf",
  "sport.GravelRide": "Gravel Ride",
  "sport.Handcycle": "Handcycle",
  "sport.HighIntensityIntervalTraining": "HIIT",
  "sport.Hike": "Hike",
  "sport.IceSkate": "Ice Skate",
  "sport.InlineSkate": "Inline Skate",
  "sport.Kayaking": "Kayaking",
  "sport.Kitesurf": "Kitesurf",
  "sport.MountainBikeRide": "Mountain Bike Ride",
  "sport.NordicSki": "Nordic Ski",
  "sport.Padel": "Padel",
  "sport.PhysicalTherapy": "Physical Therapy",
  "sport.Pickleball": "Pickleball",
  "sport.Pilates": "Pilates",
  "sport.Racquetball": "Racquetball",
  "sport.Ride": "Ride",
  "sport.RockClimbing": "Rock Climb",
  "sport.RollerSki": "Roller Ski",
  "sport.Rowing": "Rowing",
  "sport.Run": "Run",
  "sport.Sail": "Sail",
  "sport.Skateboard": "Skateboard",
  "sport.Snowboard": "Snowboard",
  "sport.Snowshoe": "Snowshoe",
  "sport.Soccer": "Soccer",
  "sport.Squash": "Squash",
  "sport.StairStepper": "Stair-Stepper",
  "sport.StandUpPaddling": "Stand Up Paddling",
  "sport.Surfing": "Surfing",
  "sport.Swim": "Swim",
  "sport.TableTennis": "Table Tennis",
  "sport.Tennis": "Tennis",
  "sport.TrailRun": "Trail Run",
  "sport.Velomobile": "Velomobile",
  "sport.VirtualRide": "Virtual Ride",
  "sport.VirtualRow": "Virtual Rowing",
  "sport.VirtualRun": "Virtual Run",
  "sport.Volleyball": "Volleyball",
  "sport.Walk": "Walk",
  "sport.WeightTraining": "Weight Training",
  "sport.Wheelchair": "Wheelchair",
  "sport.Windsurf": "Windsurf",
  "sport.Workout": "Workout",
  "sport.Yoga": "Yoga"
}
